import customAxios from "./axios";
import CONFIG from "../../config";

export const getAllCompany = (page) =>
  customAxios.get(`${CONFIG.apiURL}/Company/GetAllCompany?page=${page}`);

export const createCompanyService = (payload) =>
  customAxios.post(`${CONFIG.apiURL}/Company/Create`, payload);

export const getCompany = (id) =>
  customAxios.get(`${CONFIG.apiURL}/Company/GetCompany?id=${id}`);

export const updateCompany = ({ id, payload }) =>
  customAxios.put(`${CONFIG.apiURL}/Company/Update?id=${id}`, payload);
